<div class="wrapper">
  <div class="chart-label" fxFlex="column">
    <div class="severity-count">{{ totalCount }}</div>
    <div class="description">{{ description }}</div>
  </div>
  <div [chart]="chart"></div>
</div>
